var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.6663 47.1805V73.4757C73.6663 74.7819 72.7978 75.6533 71.4984 75.6533L8.50252 75.6495C7.20221 75.6495 6.3347 74.778 6.3347 73.4718V47.1777C6.3347 45.8714 5.46718 45 4.16782 45C2.86846 45 2 45.8714 2 47.1777V73.4718C2 77.1721 4.81607 80 8.49871 80H71.4946C75.1782 80 77.9933 77.1721 77.9933 73.4718L78 47.1777C78 45.8714 77.1325 45.0038 75.8331 45.0038C74.5338 45.0038 73.6663 45.8753 73.6663 47.1805Z",
    fill: "#1A3F54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.3718 13.8004V6.59981C26.3718 5.28081 27.2487 4.40019 28.5606 4.40019H50.4357C51.7486 4.40019 52.6235 5.28081 52.6235 6.59981V13.8004C52.6235 15.1194 53.5003 16 54.8113 16C56.1242 16 57.0001 15.1194 57.0001 13.8004V6.59981C57.0001 2.86153 54.1577 0.00387085 50.4386 0.00387085L28.5615 0C24.8433 0 22.0001 2.85766 22.0001 6.59594V13.7965C21.9972 15.1194 22.8731 16 24.185 16C25.4959 16 26.3718 15.1194 26.3718 13.8004Z",
    fill: "#F27A76"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2549 53.7498H43.7498V45.2512H35.2549V53.7498ZM47.9935 54.91V43.1027C47.9832 41.8405 47.1365 41 45.8711 41H33.127C31.8532 41 31.0028 41.8508 31.0028 43.1251V44.8239L31 49.0732L31.0075 49.0751V55.8749C31.0075 57.1492 31.8579 58 33.1317 58H45.8758C47.1496 58 48 57.1492 48 55.8749V54.91H47.9935Z",
    fill: "#F27A76"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.47609 19C2.89937 19 0 21.932 0 25.548V34.523C0 37.5818 2.16028 40.2006 4.9656 40.8538L23.9738 46.9436C25.2905 47.2414 26.5417 46.2269 26.5417 44.8618C26.5417 43.8627 25.8567 42.9981 24.8925 42.78L6.04479 36.7076C4.96465 36.4895 4.31866 35.6153 4.31866 34.523V25.5518C4.31866 24.3452 5.28575 23.3682 6.47894 23.3682H73.523C74.7152 23.3682 75.6813 24.3452 75.6813 25.5518L75.6794 34.523C75.6794 35.6153 75.0296 36.4895 73.9533 36.7076L54.0971 42.781C53.1328 42.999 52.4479 43.8636 52.4479 44.8627V44.8656C52.4479 46.2308 53.699 47.2443 55.0157 46.9484L75.0391 40.8577C77.8407 40.2006 80 37.5818 80 34.523V25.5489C80 21.932 77.1006 19 73.523 19H6.47609Z",
    fill: "#3E90C1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProf);
export default __webpack_public_path__ + "static/media/prof.3d2aa1651abe00254aa7c8c229b52acf.svg";
export { ForwardRef as ReactComponent };